import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useLocation } from 'react-router-dom';
import styles from './Header.module.css';
import { UserIcon, LogOutIcon } from './Icons';

const Header = ({ onMenuClick, onProfileClick }) => {
  const { user, isAuthenticated, logout } = useAuth0();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
    setShowUserMenu(false);
  };

  // Get display name - prioritize profile name over auth user name
  const getDisplayName = () => {
    if (user?.name) {
      return user.name;
    }
    return 'User';
  };

  // Get display email - prioritize profile email over auth user email
  const getDisplayEmail = () => {
    if (user?.email) {
      return user.email;
    }
    return 'user@example.com';
  };

  // Get user initials for avatar
  const getUserInitials = (name, email) => {
    if (name && name !== 'User') {
      return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }
    if (email && email !== 'user@example.com') {
      return email.split('@')[0].slice(0, 2).toUpperCase();
    }
    return 'U';
  };

  return (
    <>
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <div 
            className={styles.menuButton} 
            onClick={onMenuClick}
            title="Toggle Sidebar"
          >
            <img 
              src="/menu.svg"
              alt="Menu"
              className={styles.menuIcon}
            />
          </div>
          <Link to="/" className={styles.logo}>
            <img 
              src="/IMG_7921.jpg" 
              alt="Quila" 
              className={styles.logoImage}
            />
          </Link>
        </div>
        <nav className={styles.nav}>
          <Link to="/" className={`${styles.navLink} ${location.pathname === '/' ? styles.active : ''}`}>
            Home
          </Link>
          <Link to="/compass" className={`${styles.navLink} ${location.pathname === '/compass' ? styles.active : ''}`}>
            Compass
          </Link>
          <Link to="/explore" className={`${styles.navLink} ${location.pathname === '/explore' ? styles.active : ''}`}>
            Explore
          </Link>
          <Link to="/pathway-planner" className={`${styles.navLink} ${location.pathname === '/pathway-planner' ? styles.active : ''}`}>
            Pathway Planner
          </Link>
          <Link to="/analytics" className={`${styles.navLink} ${location.pathname === '/analytics' ? styles.active : ''}`}>
            Analytics
          </Link>
          <Link to="/counselor-connect" className={`${styles.navLink} ${location.pathname === '/counselor-connect' ? styles.active : ''}`}>
            Counselor Connect
          </Link>
        </nav>
        <div className={styles.userSection}>
          <div 
            className={styles.avatar}
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            {isAuthenticated ? (
              <div className={styles.avatarCircle}>
                {getUserInitials(getDisplayName(), getDisplayEmail())}
              </div>
            ) : (
              <UserIcon size={24} color="#718096" />
            )}
            <span className={styles.avatarDropdown}></span>
          </div>
        </div>

        {/* User Menu Dropdown */}
        {showUserMenu && (
          <div className={styles.userMenu}>
            <div className={styles.userMenuHeader}>
              <div className={styles.userMenuAvatar}>
                {getUserInitials(getDisplayName(), getDisplayEmail())}
              </div>
              <div className={styles.userMenuInfo}>
                <div className={styles.userMenuName}>{getDisplayName()}</div>
                <div className={styles.userMenuEmail}>{getDisplayEmail()}</div>
              </div>
            </div>
            <div className={styles.userMenuActions}>
              <button 
                className={styles.userMenuButton}
                onClick={handleLogout}
              >
                <LogOutIcon size={16} />
                Sign Out
              </button>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header; 